import photo1 from '../../assets/htut.png';
import photo2 from '../../assets/locke.png';
import photo3 from '../../assets/tees.png';
import photo4 from '../../assets/pal.png';

const quoteData = [
  {
    copy:
      '“Extensive wait times for CAR T treatment may lead to suboptimal outcomes for those patients who are eligible and could benefit from this therapy. In patients who have very aggressive cancer, as is often the case in multiple myeloma that no longer responds to treatment, time is simply not on their side.”',
    name: '—Dr. Myo Htut,',
    title:
      'Associate Professor, Division of Multiple Myeloma, Department of Hematology and Hematopoietic Cell Transplantation, City of Hope in Los Angeles',
    image: photo1
  },
  {
    copy:
      '“Allogeneic CAR T cell therapy offers the opportunity to address and overcome some of the logistical and manufacturing challenges we are seeing in daily practice.”',
    name: '—Dr. Fred Locke,',
    title:
      'Chair of the Department of Blood and Marrow Transplant and Cellular Immunotherapy at Moffitt Cancer Center in Tampa, Florida',
    image: photo2
  },
  {
    copy:
      '“The ability to genetically re-engineer a patient’s own immune cells—and now someone else’s immune cells—in order to harness the power of immunotherapy to kill cancer is something that few thought would ever be possible.”',
    name: '—Dr. Michael Tees,',
    title:
      'Associate Member Physician, Director of the Lymphoma Program at the Colorado Blood Cancer Institute in Denver, Colorado',
    image: photo3
  },
  {
    copy:
      '“It’s critical that we approach these cancers in a way that uniquely targets each tumor’s biological make up. There are a number of unique targets that we can exploit.”',
    name: '—Dr. Monty Pal,',
    title: 'Oncologist and Co-Director of the City of Hope Kidney Cancer Program',
    image: photo4
  }
];

export default quoteData;
